import axios from "axios";
import config from "./api-config";

export class ApiService {
  constructor(apiPath) {
    this.requester = axios.create({
      baseURL: apiPath ?? config["home-edge"],
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
      withCredentials: true,
    });
  }

  get = (path) => {
    return this.requester.get(path);
  };

  async post(path, body) {
    return this.requester.post(path, body);
  }
}

export default new ApiService();
